import { render } from "./Link.vue?vue&type=template&id=390bd254&scoped=true&ts=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

import "./Link.vue?vue&type=style&index=0&id=390bd254&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390bd254"]])

export default __exports__